import _get from 'lodash/get';
import { renewJwtWithProfile } from '../token/token.actions';
import { setCurrentSectionCode } from '../layout/layout.section.actions';
import { getOriginalTarget } from './lock.utils';

export const refreshAuth = item => dispatch => {
  const section = _get(getOriginalTarget(item), 'value_layout.section');
  if (section) {
    dispatch(setCurrentSectionCode(section));
  }

  const reasonAttributes = _get(item, 'item.action.target.value_lock.reasonAttributes');
  const { profileUid } = reasonAttributes;
  dispatch(renewJwtWithProfile(profileUid));
};
